'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
const OperatorInterfaces_1 = require('../models/OperatorInterfaces');
const ramda_1 = require('ramda');
const equationTypePredicates_1 = require('./equationTypePredicates');
const walkEquation_1 = require('./walkEquation');
exports.findLastEquation = logicTree => {
    const {right, left} = logicTree;
    if (equationTypePredicates_1.isEquation(right)) {
        return right;
    }
    if (equationTypePredicates_1.isEquation(left)) {
        return left;
    }
    return logicTree;
};
exports.findLastElement = logicTree => {
    const {left, right, operator} = logicTree;
    if (exports.isTree(logicTree)) {
        if (logicTree.right) {
            return exports.findLastElement(logicTree.right);
        }
        if (logicTree.operator) {
            return logicTree.operator;
        }
    }
    return right || operator || left;
};
exports.isComplete = equation => {
    return !!equation.left && !!equation.operator && !!equation.right;
};
exports.isTree = equation => {
    return !!equation.left && equation.left.type === 'equation';
};
exports.addToEquation = (logicTree, part) => {
    const right = logicTree.right || { type: 'equation' };
    const {left} = logicTree;
    if (equationTypePredicates_1.isOperator(part)) {
        if (equationTypePredicates_1.isEquationOperator(part)) {
            return {
                type: 'equation',
                left: logicTree,
                operator: part
            };
        }
        if (exports.isTree(logicTree)) {
            return Object.assign({}, logicTree, { right: exports.addToEquation(right, part) });
        }
        return Object.assign({}, logicTree, { operator: part });
    } else {
        if (exports.isTree(logicTree)) {
            return Object.assign({}, logicTree, { right: exports.addToEquation(right, part) });
        }
        if (!left) {
            return Object.assign({}, logicTree, { left: part });
        }
        return Object.assign({}, logicTree, { right: part });
    }
};
exports.deleteLastElement = logicTree => {
    if (equationTypePredicates_1.isEquation(logicTree.right) && logicTree.right.left) {
        return Object.assign({}, logicTree, { right: exports.deleteLastElement(logicTree.right) });
    }
    if (equationTypePredicates_1.isEquation(logicTree.left)) {
        return logicTree.left;
    }
    if (logicTree.right) {
        return ramda_1.dissoc('right', logicTree);
    }
    if (logicTree.operator) {
        return ramda_1.dissoc('operator', logicTree);
    }
    return ramda_1.dissoc('left', logicTree);
};
exports.findEquationVariables = logicTree => {
    const variables = [];
    walkEquation_1.walkEquation(logicTree, element => {
        if (equationTypePredicates_1.isEquationVariable(element)) {
            variables.push(element);
        }
    });
    return variables;
};
exports.getOperandValue = (variables, operand) => {
    if (equationTypePredicates_1.isEquationVariable(operand)) {
        return ramda_1.prop(operand.variableId, variables);
    } else if (equationTypePredicates_1.isEquationLiteral(operand)) {
        return operand.value;
    }
};
const slotToLiteral = (slot, slotValues) => ({
    type: 'equationLiteral',
    dataType: slot.dataType,
    value: slotValues[slot.id]
});
exports.replaceSlots = (equation, slotValues) => {
    if (!equation) {
        return equation;
    }
    let {left, right} = equation;
    if (equationTypePredicates_1.isEquation(left)) {
        left = exports.replaceSlots(left, slotValues);
    }
    if (equationTypePredicates_1.isEquation(right)) {
        right = exports.replaceSlots(right, slotValues);
    }
    if (equationTypePredicates_1.isEquationSlot(left)) {
        left = slotToLiteral(left, slotValues);
    }
    if (equationTypePredicates_1.isEquationSlot(right)) {
        right = slotToLiteral(right, slotValues);
    }
    return Object.assign({}, equation, {
        left,
        right
    });
};
exports.evaluateTree = (logicTree, variables) => {
    if (!logicTree) {
        return false;
    }
    const {left, operator, right} = logicTree;
    let leftValue;
    let rightValue;
    if (equationTypePredicates_1.isEquation(left)) {
        leftValue = exports.evaluateTree(left, variables);
    } else {
        leftValue = exports.getOperandValue(variables, left);
    }
    if (equationTypePredicates_1.isEquation(right)) {
        rightValue = exports.evaluateTree(right, variables);
    } else {
        rightValue = exports.getOperandValue(variables, right);
    }
    if (equationTypePredicates_1.isTextOperator(operator)) {
        if (operator.operator === OperatorInterfaces_1.TextOperatorTypes.INCLUDES) {
            return ramda_1.contains(ramda_1.toLower(rightValue ? `${ rightValue }` : ''), ramda_1.toLower(leftValue ? `${ leftValue }` : ''));
        }
        const res = ramda_1.equals(`${ leftValue }`, `${ rightValue }`);
        if (operator.operator === OperatorInterfaces_1.TextOperatorTypes.NOT_EQUALS) {
            return ramda_1.not(res);
        }
        return res;
    }
    if (equationTypePredicates_1.isEquationOperator(operator)) {
        if (operator.operator === OperatorInterfaces_1.EquationOperatorTypes.AND) {
            return ramda_1.and(leftValue, rightValue);
        }
        return ramda_1.or(leftValue, rightValue);
    }
    return false;
};    //# sourceMappingURL=data:application/json;base64,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
